<script setup>

import { 
  kToolbar,
  kButton
} from 'konsta/vue';

import {useBooking} from '@/stores/booking'
const bookingStore = useBooking();

</script>

<template>
  <k-toolbar class="right-0 bottom-0 fixed w-full block md:w-2/3">
    <div class="w-full h-auto flex space-x-5">
      <k-button 
        outline 
        class="text-gray-400 border-gray-400 px-6 py-3"
        @click="bookingStore.goBackStep()">Indietro</k-button>
      <k-button 
        @click="bookingStore.goNextStep()"
        :disabled="!bookingStore.next_enabled"
        :class="[
          bookingStore.next_enabled ? '!bg-primary !text-white px-6 py-3' : '!bg-gray-200 !text-white px-6 py-3'
        ]"
        >
        Avanti
      </k-button>
    </div>
  </k-toolbar>
</template>